import React, { useEffect, useState } from "react";
import {
  getStockModelsService,
  createFreeProductService,
} from "../../../services/apiService";

const initialState = {
  mainProductId: "",
  freeProductId: "",
  price: "",
  qty: "",
  productqty: "",
  fromdate: "",
  todate: "",
  active: 1,
};

const FreeProductForm = () => {
  const [formData, setFormData] = useState(initialState);
  const [models, setModels] = useState([]);

  /* 🔹 Load models */
  useEffect(() => {
    loadModels();
  }, []);

  const loadModels = async () => {
    try {
      const res = await getStockModelsService();
      setModels(res?.Data || []);
    } catch (err) {
      console.error(err);
    }
  };

  /* 🔹 Normal input */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  /* 🔹 Submit */
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      productid: formData.mainProductId,
      feeproductid: formData.freeProductId,
      qty: formData.qty,
      price: formData.price,
      productqty: formData.productqty,
      active: formData.active,
      fromdate: `${formData.fromdate} 00:00:00`,
      todate: `${formData.todate} 00:00:00`,
    };

    try {
      await createFreeProductService(payload);
      alert("Free product created ✅");
      setFormData(initialState); // 🔥 reset works
    } catch (err) {
      console.error(err);
      alert("Failed ❌");
    }
  };
const isFormValid =
  formData.qty &&
  Number.isInteger(Number(formData.qty)) &&
  formData.productqty &&
  Number.isInteger(Number(formData.productqty)) &&
  formData.fromdate &&
  formData.todate;

  return (
    <div className="free-wrapper">
        <h4 className="title">Create free item</h4>
      <form className="free-form" onSubmit={handleSubmit}>
        <div className="grid">
          {/* Main Model */}
          <div>
            <label>Main Model No</label>
            <select
              value={formData.mainProductId}
              onChange={(e) =>
                setFormData((p) => ({ ...p, mainProductId: e.target.value }))
              }
            >
              <option value="">Select</option>
              {models.map((m) => (
                <option key={m.productid} value={m.productid}>
                  {m.modelno}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label>Main Product ID</label>
            <input value={formData.mainProductId} readOnly />
          </div>

          {/* Free Model */}
          <div>
            <label>Free Model No</label>
            <select
              value={formData.freeProductId}
              onChange={(e) =>
                setFormData((p) => ({ ...p, freeProductId: e.target.value }))
              }
            >
              <option value="">Select</option>
              {models.map((m) => (
                <option key={m.productid} value={m.productid}>
                  {m.modelno}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label>Free Product ID</label>
            <input value={formData.freeProductId} readOnly />
          </div>

          <div>
            <label>Price</label>
            <input name="price" value={formData.price} onChange={handleChange} />
          </div>

          <div>
            <label>Quantity</label>
            <input name="qty" value={formData.qty} onChange={handleChange} />
          </div>

          <div>
            <label>Valid From</label>
            <input
              type="date"
              name="fromdate"
              value={formData.fromdate}
              onChange={handleChange}
            />
          </div>

          <div>
            <label>Valid To</label>
            <input
              type="date"
              name="todate"
              value={formData.todate}
              onChange={handleChange}
            />
          </div>

          <div>
            <label>Main Product Qty</label>
            <input
              name="productqty"
              value={formData.productqty}
              onChange={handleChange}
            />
          </div>

          <div>
            <label>Active</label>
            <select name="active" value={formData.active} onChange={handleChange}>
              <option value={1}>Active</option>
              <option value={0}>Inactive</option>
            </select>
          </div>
        </div>

       <button
  type="submit"
  className="submit-btn"
  disabled={!isFormValid}
>
  Submit
</button>

      </form>

      {/* CSS */}
      <style>{`
      .title {
  color: #005487;
  margin: 0 auto;      /* centers block element horizontally */
  text-align: center;  /* centers the text inside */
}

        .free-wrapper {
          padding: 20px;
          background: #fff;
        }
.submit-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}

        .grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 16px;
        }

        label {
          font-size: 13px;
          margin-bottom: 4px;
          display: block;
          color : #464849;
        }

        input, select {
          width: 100%;
          padding: 8px;
          font-size: 13px;
          border: 1px solid #d1d5db;
          border-radius: 4px;
               color : #464849;
        }

        input[readonly] {
          background: #f3f4f6;
               color : #464849;
        }

        .submit-btn {
          margin-top: 20px;
          background: #0d6efd;
          color: white;
          padding: 8px 18px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }

        .submit-btn:hover {
          background: #084298;
        }
      `}</style>
    </div>
  );
};

export default FreeProductForm;
